import IdleJs from 'idle-js';

import {
  SET_IDLE_ON,
  SET_IDLE_OFF,
} from '../mutation-types';

export default {
  namespaced: true,
  state: {
    idleVue: null,
    idleTime: 540000, // 9 minutes
    idleStarted: false,
    isUserIdle: false,
  },
  mutations: {
    [SET_IDLE_ON](state) {
      state.isUserIdle = true;
    },
    [SET_IDLE_OFF](state) {
      state.isUserIdle = false;
    },
    setIdleTime(state, idleTime) {
      state.idleTime = idleTime;
    },
    setIdleStarted(state, idleStarted) {
      state.idleStarted = idleStarted;
    },
  },
  actions: {
    startIdle({ commit, state }, options = null) {
      if (state.idleVue) state.idleVue.stop();

      if (options && options.idleTime) {
        commit('setIdleTime', options.idleTime);
      }

      state.idleVue = new IdleJs({
        idle: state.idleTime,
        keepTracking: (options && options.keepTracking) || true,
        startAtIdle: (options && options.startAtIdle) || true,
        events: ['mousemove', 'keydown', 'mousedown', 'touchstart'],
        onIdle() {
          commit('SET_IDLE_ON', true);
        },
        onActive() {
          commit('SET_IDLE_OFF', false);
        },
      });

      state.idleVue.start();
      commit('setIdleStarted', true);
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/idle.js